// extracted by mini-css-extract-plugin
export default {"alert":"GlobalSnackbar_alert__lPwvH"};